import { render, staticRenderFns } from "./SPRCollapsible.vue?vue&type=template&id=28bf7ee6&scoped=true"
import script from "./SPRCollapsible.vue?vue&type=script&lang=js"
export * from "./SPRCollapsible.vue?vue&type=script&lang=js"
import style0 from "./SPRCollapsible.vue?vue&type=style&index=0&id=28bf7ee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28bf7ee6",
  null
  
)

export default component.exports